export interface O365Claims {
  unique_name: string;
  oid: string;
}

export const MS_TEAMS_APP = 'microsoft.teams';
